import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportDefinitionModel} from '../reportDefinition.model';
import {ReportDefinitionComponentConverter} from './reportDefinitionComponent.converter';
import {ReportDefinitionEmailConfigurationConverter} from "./reportDefinitionEmailConfiguration.converter";
import {
    CommunicationContentModelSummaryConverter
} from "../../../../../communication/content-model/api/entity/converter/communicationContentModelSummary.converter";

@Injectable()
export class ReportDefinitionConverter extends HttpModelConverter<ReportDefinitionModel> {

    constructor(private reportDefinitionComponentConverter: ReportDefinitionComponentConverter,
                private reportDefinitionEmailConfigurationConverter: ReportDefinitionEmailConfigurationConverter,
                private communicationContentModelSummaryConverter: CommunicationContentModelSummaryConverter) {
        super();
    }
    protected createInstance(): ReportDefinitionModel {
        return new ReportDefinitionModel();
    }

    protected enrichObject(result: ReportDefinitionModel, src: ReportDefinitionModel) {
        result.components = this.reportDefinitionComponentConverter.convertFromArray(src.components);
        result.defaultIntro = this.communicationContentModelSummaryConverter.convert(src.defaultIntro);
        result.defaultSalutation = this.communicationContentModelSummaryConverter.convert(src.defaultSalutation);
        result.emailConfigurations = this.reportDefinitionEmailConfigurationConverter.convertFromArray(src.emailConfigurations);
    }

}
